import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'echarts'
import ECharts from 'vue-echarts'
import '../src/utils/rem'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import Video from 'video.js'
import 'video.js/dist/video-js.css'

Vue.use(ElementUI);
console.log('ECharts', ECharts);
Vue.component('VueEcharts2', ECharts)
Vue.config.productionTip = false


Vue.prototype.$video = Video  // 在vue的原生里添加了Video这个标签，增强了vue的功能性
window.addEventListener('load', function () {
  if (router.path != '/') { // /date 表示日期选择路由
    router.replace('/').catch(err => { })
    // console.log("dsada");
    // if(flag){
    //   router.replace('/phoneLogin').catch(err => {})
    // }else{
    //   router.replace('/').catch(err => {}) // 列表页面的路由
    // }
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
